function hidePrices() {
  // var threshold = window.globalThreshold || 10000;
  var threshold = window.globalThreshold || 0;

  var label = window.HIDE_PRICE_SETTINGS?.label || '';

  function parsePrice(text) {
    return parseFloat(text.replace(/[^0-9.]/g, ''));
  }

  function maybeHide(el) {
    var text = el.textContent.trim();
    var amount = parsePrice(text);
    if (!isNaN(amount) && amount > threshold) {
      el.textContent = label;
      el.style.fontStyle = 'italic';
      el.style.color = 'inherit';
    }
  }

  function run() {
    var selectors = ['.product__price', '.price-item.price-item--regular'];
    selectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        maybeHide(el);
      });
    });

    // Hide add-to-cart button if price is above threshold
    var submitButton = document.querySelector('[id^="ProductSubmitButton-"], [type="submit"][name="add"]');
    var quantityInput = document.querySelector('.product-form__input.product-form__quantity');
    var priceDisplay = document.querySelector('.price.price--large.price--show-badge');

    if (submitButton || quantityInput || priceDisplay) {
      submitButton.style.display = 'none'; // Hide by default
      if (quantityInput) {
        quantityInput.style.display = 'none'; // Hide quantity by default
      }
      if (priceDisplay) {
        priceDisplay.style.display = 'none'; // Hide price display by default
      }

      var priceElements = document.querySelectorAll('.product__price, .price-item.price-item--regular');
      priceElements.forEach(function (priceEl) {
        var amount = parsePrice(priceEl.textContent.trim());
        if (!isNaN(amount) && amount <= threshold) {
          if (submitButton) {
            submitButton.style.display = 'block'; // Show only if price <= threshold
          }
          if (quantityInput) {
            quantityInput.style.display = 'block'; // Show quantity only if price <= threshold
          }
          if (priceDisplay) {
            priceDisplay.style.display = 'block'; // Show price display only if price <= threshold
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    console.log('Document is loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', run);
  } else {
    console.log('Document already loaded, running immediately...');
    run();
  }

  // Watch for DOM changes and rerun when new elements are added
  let debounceTimer;
  const observer = new MutationObserver(function (mutations) {
    // Debounce: wait 100ms after mutations stop before running
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      run();
    }, 100);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: false
  });
}

// Call it immediately
hidePrices();
